import { Locales } from 'app/[locale]/hooks/useTranslate';
import { Paths } from './Paths';

/**
 * url Path를 생성 용도
 */
export class PathName {
  locale: Locales;
  workspaceId: string;
  recordId: string | number;
  recordQuery: { tab?: string; query?: string; startAt?: string; referer?: string };
  sharedRecordQuery: { record?: string; pw?: string };
  memberQuery: { tab?: string };
  sharedId: string;
  licenseQuery: { tab?: string };
  query: Record<string, string>;
  provider: string;
  teamId: string;

  constructor(public readonly path: Paths) {}

  public setLocale(locale: Locales): PathName {
    this.locale = locale;
    return this;
  }

  public setWorkspaceId(workspaceId: string): PathName {
    this.workspaceId = workspaceId;
    return this;
  }

  public setRecordId(recordId: string | number): PathName {
    this.recordId = recordId;
    return this;
  }

  public setSharedId(sharedId: string): PathName {
    this.sharedId = sharedId;
    return this;
  }

  public setProvider(provider: string): PathName {
    this.provider = provider;
    return this;
  }

  public setTeamId(teamId: number): PathName {
    this.teamId = teamId.toString();
    return this;
  }

  public setMemberQuery(query: { tab?: string }): PathName {
    this.memberQuery = query;
    return this;
  }

  /**
   * record detail query
   * @param query
   * @returns
   */
  public setRecordQuery(query: {
    tab?: string;
    query?: string;
    startAt?: string;
    referer?: string;
  }): PathName {
    this.recordQuery = query;
    return this;
  }

  public setSharedRecordQuery(query: { record?: string; pw?: string }): PathName {
    this.sharedRecordQuery = query;
    return this;
  }

  public setLicenseQuery(query: { tab?: string }): PathName {
    this.licenseQuery = query;
    return this;
  }

  public setQuery(query: Record<string, string>): PathName {
    this.query = {
      ...this.query,
      ...query,
    };
    return this;
  }

  /**
   * url에 적용하기 위해 string으로 변환
   * @returns pathname 생성
   */
  public toString(): string {
    let resultPath = this.path as string;

    if (this.locale) {
      resultPath = `/${this.locale}${resultPath}`;
    }
    if (this.workspaceId) {
      if (!this.path.includes('[workspaceId]')) throw Error('path is not workspace path');
      resultPath = resultPath.replace('[workspaceId]', this.workspaceId);
    }
    if (this.recordId) {
      if (!this.path.includes('[recordId]')) throw Error('path is not record path');
      if (typeof this.recordId === 'number' && isNaN(this.recordId)) {
        throw Error('path is not record path');
      }
      resultPath = resultPath.replace('[recordId]', `${this.recordId}`);
    }
    if (this.sharedId) {
      if (!this.path.includes('[sharedId]')) throw Error('path is not share path');
      resultPath = resultPath.replace('[sharedId]', this.sharedId);
    }

    if (this.provider) {
      if (!this.path.includes('[provider]')) throw Error('path is not provider path');
      resultPath = resultPath.replace('[provider]', this.provider);
    }

    if (this.teamId) {
      if (!this.path.includes('[teamId]')) throw Error('path is not team path');
      if (typeof this.teamId === 'number' && isNaN(this.teamId)) {
        throw Error('path is not record path');
      }
      resultPath = resultPath.replace('[teamId]', this.teamId);
    }

    const params = new URLSearchParams();
    this.recordQuery?.tab && params.append('tab', this.recordQuery.tab);
    this.recordQuery?.query && params.append('query', this.recordQuery.query);
    this.recordQuery?.startAt && params.append('startAt', this.recordQuery.startAt);
    this.recordQuery?.referer && params.append('referer', this.recordQuery.referer);
    this.sharedRecordQuery?.pw && params.append('pw', this.sharedRecordQuery.pw);
    this.licenseQuery?.tab && params.append('tab', this.licenseQuery.tab);
    this.memberQuery?.tab && params.append('tab', this.memberQuery.tab);
    if (this.query) {
      Object.entries(this.query).forEach(([key, value]) => {
        params.append(key, value);
      });
    }
    if (resultPath.includes('[workspaceId]')) throw new Error('not set workspaceId');
    if (resultPath.includes('[recordId]')) throw new Error('not set recordId');
    if (resultPath.includes('[sharedId]')) throw new Error('not set sharedId');
    if (resultPath.includes('[provider]')) throw new Error('not set provider');
    if (resultPath.includes('[teamId]')) throw new Error('not set teamId');

    if (params.toString()) {
      resultPath = `${resultPath}?${params.toString()}`;
    }

    return resultPath;
  }
}
